// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalTable_root__21a3V"};